import { render, staticRenderFns } from "./SessionTopicForm.vue?vue&type=template&id=24b6def6"
import script from "./SessionTopicForm.vue?vue&type=script&lang=js"
export * from "./SessionTopicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports